import React from 'react';
import Badge from '../ui/Badge';
import Button from '../ui/Button';

export default function RequiredActionsChecklist({ actions = [], isLoading = false, error = '' }) {
  if (isLoading) {
    return <div className="text-sm sp-muted">Loading required actions…</div>;
  }
  if (error) {
    return <div className="sp-alert sp-alert--critical text-sm">{error}</div>;
  }
  if (!actions.length) {
    return <div className="text-sm sp-muted">No required actions configured.</div>;
  }

  return (
    <div className="space-y-3">
      <h4 className="sp-value" style={{ fontWeight: 600 }}>Required actions</h4>
      <div role="list" className="space-y-3">
        {actions.map((action) => (
          <div key={action.id} role="listitem" className="sp-panel sp-panel--muted p-3">
            <div className="flex items-center justify-between flex-wrap gap-3">
              <label className="flex items-start gap-2 text-sm">
                <input
                  type="checkbox"
                  checked={Boolean(action.completed)}
                  readOnly
                  aria-label={`${action.label} ${action.completed ? 'completed' : 'incomplete'}`}
                />
                <span>
                  <span className="sp-value" style={{ fontWeight: 600 }}>{action.label}</span>
                  {action.helper && <span className="block text-xs sp-muted">{action.helper}</span>}
                </span>
              </label>
              {action.completed ? (
                <Badge variant="active">Complete</Badge>
              ) : (
                <Button size="sm" variant="secondary" onClick={action.onAction} type="button">
                  {action.actionLabel || 'Resolve'}
                </Button>
              )}
            </div>
            {action.editor}
          </div>
        ))}
      </div>
    </div>
  );
}
